import React from 'react';

import { goBack } from 'core/routing';
import { staticURL } from 'core/url';
import { Tooltip } from 'components';
import { useGetSystemCondition } from 'hooks';

export const HistoryNavigation = () => {
  const { canBackInHistory } = useGetSystemCondition();

  return (
    <div className='flex ml-3'>
      <div
        className={`w-6 h-6 flex justify-center ${
          canBackInHistory
            ? 'hover:bg-gray-100 active:bg-gray-200'
            : 'bg-transparent cursor-not-allowed'
        } select-none rounded`}
        onClick={() => {
          if (canBackInHistory) {
            goBack();
          }
        }}
      >
        <Tooltip delayShow={200} place='bottom' id='back' />
        <img
          width={8}
          height={8}
          data-for='back'
          data-tip='Back in history'
          className='select-none'
          src={staticURL(
            canBackInHistory
              ? 'assets/icons/arrowLeft.svg'
              : 'assets/icons/arrowLeftGray.svg',
          )}
          alt='back'
          onDragStart={(event: any) => {
            // not allow to drag the arrow
            event.preventDefault();
          }}
        />
      </div>
      <div
        className='w-6 h-6 flex justify-center hover:bg-gray-100 active:bg-gray-200 ml-1 select-none rounded'
        onClick={() => {
          window.history.forward();
        }}
      >
        <Tooltip delayShow={200} place='bottom' id='forward' />
        <img
          width={8}
          height={8}
          data-for='forward'
          data-tip='Forward in history'
          className='rotate-180 select-none'
          src={staticURL('assets/icons/arrowLeft.svg')}
          alt='back'
          onDragStart={(event: any) => {
            // not allow to drag the arrow
            event.preventDefault();
          }}
        />
      </div>
    </div>
  );
};
